import { useState } from "react";
import { Plus, Pencil, Building2 } from "lucide-react";
import { toast } from "sonner";
import { api, fmtErr } from "../lib/api";
import { useSite } from "../lib/site";
import { PageHeader } from "../components/ModulePage";
import { FormDialog } from "../components/FormDialog";
import { Button } from "../components/ui/button";

const FIELDS = [
  { name: "name", label: "Site name", type: "text", required: true },
  { name: "type", label: "Site type", type: "select", options: ["Distribution Centre", "Warehouse", "Paper Manufacturing Plant", "Industrial Facility"] },
  { name: "manager", label: "Site manager", type: "text" },
  { name: "address", label: "Address", type: "textarea" },
];

export default function Sites() {
  const { sites, site, select, reload } = useSite();
  const [edit, setEdit] = useState(null);
  const save = async (v) => {
    try {
      const r = v.id ? await api.put(`/sites/${v.id}`, v) : await api.post("/sites", v);
      toast.success("Site saved");
      await reload();
      if (!v.id) select(r.data.id);
    } catch (e) { toast.error(fmtErr(e)); throw e; }
  };
  return (
    <div>
      <PageHeader eyebrow="Administration" title="Sites" description="Each site has its own dashboard, registers, inspections, work orders, incidents and reports. Give users access on the Users page.">
        <Button onClick={() => setEdit({})} className="tap bg-rose-600 hover:bg-rose-700" data-testid="add-site-btn"><Plus className="mr-1 h-4 w-4" />Add site</Button>
      </PageHeader>
      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
        {sites.map((s) => (
          <div key={s.id} className={`panel p-5 ${site?.id === s.id ? "border-rose-500/60" : ""}`} data-testid={`site-card-${s.id}`}>
            <div className="flex items-start justify-between">
              <Building2 className="h-6 w-6 text-rose-400" />
              <Button size="icon" variant="ghost" onClick={() => setEdit(s)} data-testid={`edit-site-${s.id}`}><Pencil className="h-4 w-4" /></Button>
            </div>
            <p className="font-display mt-2 text-xl font-bold uppercase">{s.name}</p>
            <p className="eyebrow text-[10px]">{s.type || "Site"}</p>
            <p className="mt-2 text-sm text-slate-400">{s.manager || "No manager set"}{s.address ? ` - ${s.address}` : ""}</p>
            {site?.id !== s.id && <Button variant="outline" size="sm" className="mt-3 border-slate-700 bg-transparent" onClick={() => select(s.id)} data-testid={`switch-site-${s.id}`}>Switch to this site</Button>}
          </div>
        ))}
      </div>
      <FormDialog open={!!edit} onOpenChange={(o) => !o && setEdit(null)} title={edit?.id ? "Edit site" : "New site"} fields={FIELDS} initial={edit} onSubmit={save} testid="site-form" />
    </div>
  );
}
